import { Provider } from '@angular/core'
import { InflightPromise } from 'shared-services'

export const inflightPromiseProvider: Provider = [
  {
    provide: InflightPromise,
    useValue: new InflightPromise(),
  },
]
